export default __webpack_public_path__ + "static/media/user-group.c2456f58.svg";